/* eslint-disable no-bitwise */
// 订单状态 Code
export const ORDER_STATUS_CODE = {
  CREATED: 1, // 待支付
  PAYED: 2, // 等待商家接单中
  CONFIRMED: 3, // 商家已接单
  GRAB: 4, // 外送员赶往商家
  ARRIVAL: 5, // 外送员取餐中
  FETCH: 6, // 外送员送餐中
  FINISHED: 7, // 已完成
  CANCELED: 8, // 已取消 外卖&自提
  REFUND: 9, // 申请退款中
  PICKUP_WAIT_PAY: 10, // 自提-待支付
  PICKUP_WAIT_TAKE_ORDER: 11, // 自提-待接单
  PICKUP_SHOP_TAKE_ORDER: 12, // 自提-已接单
  PICKUP_SHOP_FOOD_READY: 13, // 自提-已出餐，待取餐
  PICKUP_ORDER_COMPLETE: 14, // 自提-已完成
};

// 退款状态码
export const AFTER_SALE_CODE = {
  REFUNDING: 5001, // 退款中
  REFUND_SUCCESS: 5002, // 退款成功
  REFUND_FAIL: 5003, // 退款失败
};

// 订单取货方式
export const USER_GET_MODE = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
};

// 订单退款类型
export const ORDER_REFUND_TYPE = {
  FULL_REFUND: 0,
  PART_REFUND: 1,
};

// 店铺Region
export const SHOP_REGION = {
  HK: 'HK',
  SA: 'SA',
};

// 载具类型
export const CARRIER_TYPE = {
  MOTORBIKE: 1,
  CAR: 2,
};

export const FIXED_SUBCONTENT_TYPE = {
  platform: '1',
  delivery: '2',
};

// 拉黑骑手模块弹窗类型
export const BLOCK_POPUP_TYPE = {
  BLOCK_RIDER: 1,
  UNBLOCK_RIDER: 2,
  BLOCK_LIST_FULL: 3,
};

/**
 * 骑手拉黑状态，1为被拉黑，2为未被拉黑
 */
export const RIDER_BLOCKSTATUS_TYPE = {
  BLOCKED: 1,
  UNBLOCKED: 2,
};

/**
 * 菜品活动类型
 */
enum LX_SKU_ACTIVITY_TYPE {
  FULL_REDUCTION = 0, // 满减
  FULL_DISCOUNT = 1, // 满折
  DISCOUNT_FOOD = 2, // 折扣
}

export const ORDER_SOURCE = {
  main: 0,
  fixedPrice: 1,
};

/**
 * promotion 类型
 */
const PROMOTION_TYPE = {
  PROMOTION_TYPE_PRODUCT_TOTAL: 1, // 商品小计
  PROMOTION_TYPE_PRICE_SPREAD: 2, // 消费补差价
  PROMOTION_TYPE_DISCOUNT: 3, // 优惠券
  PROMOTION_TYPE_DELIVERY: 4, // 配送费
  PROMOTION_TYPE_PLATFORM: 5, // 平台费
  PROMOTION_TYPE_TIPS: 6, // 小费， 只在订单详情页下发
  PROMOTION_TYPE_FIXED_TOTAL: 7, // 一口价总价
  PROMOTION_TYPE_PROMOTION_TOTAL: 8, // 具体优惠金额
  PROMOTION_TYPE_NON_MACKETING: -1, // 非营销条目
};

const ORDER_INFO_RESPONSE_BODY: {[key: string]: string;} = ['finBen'].reduce((acc, item) => {
  acc[item] = item;

  return acc;
}, {});

/**
 * 菜品标签类型
 */
enum SKU_TAG_TYPE {
  DISCOUNT_FOOD = 1, // 折扣菜享受优惠
  DISCOUNT_FOOD_FIXED_PRICE = 3, // 折扣菜享受优惠（一人食切换为折扣菜新增）
}

/**
 * 折扣菜信息
 */
enum LX_PROMO_DISHES_TYPE {
  NORMAL = 0, // 非折扣菜商品
  DISCOUNT_FOOD = 1, // 折扣菜商品
}

/**
 * 优惠券使用状态
 */
enum USE_COUPON_STATUS {
  UNSELECT = 2, // 未选择优惠券
  UNAVAILABLE = 3, // 无可用优惠券
  SELECTED = 5, // 已选优惠券
}

/**
 * 接口返回错误码
 */
enum RESPONSE_ERROR_CODE {
  DUPLICATE_PAYMENT = 2000014, // 重复支付
}

/**
 * 弹窗类型
 */
const POPUP_VIEW_TYPE = {
  ORDER_RUSH: 1 << 0, // 订单催单弹窗
  ORDER_FEEDBACK: 1 << 1, // 订单配送反馈弹窗
  ORDER_EVALUATE: 1 << 2, // 订单评价订单弹窗
  ORDER_RESOURCE: 1 << 3, // 订单资源位弹窗
  RIDER_CHARGE: 1 << 4, // 骑手打赏弹窗
  PRIVACY_NO: 1 << 5, // 隐私号弹窗
  ORDER_SUMMARY: 1 << 6, // 订单详情弹窗
  STORE_REVIEW: 1 << 7, // 应用商店评价弹窗
  NAVI_OVERLAY: 1 << 8, // 导航浮层
  COMMON_OVERLAY: 1 << 9, // 通用弹窗浮层
  BAD_WEATHER_RUSH: 1 << 10, // 恶劣天气-催单-拦截弹窗
  BAD_WEATHER_REFUND: 1 << 11, // 恶劣天气-退款-拦截弹窗
  ORDER_OVERTIME: 1 << 12, // 订单超时弹窗
  PREPARE_FOOD_SLOW: 1 << 13, // 商家出餐慢提示弹窗
  NPS_CARD_MODEL: 1 << 14, // NPS弹窗
  ORDER_PROMISE: 1 << 15, // 准时保弹窗
  BLOCK_RIDER: 1 << 16, // 拉黑骑手
  DELIVERY_TIPS: 1 << 17, // 配送提示
};

/**
 * 弹窗优先级
 */
const POPUP_VIEW_PRIORITY = {
  DEFAULT: 1, // 通用弹窗
  [POPUP_VIEW_TYPE.PREPARE_FOOD_SLOW]: 90, // 订单超时提醒优先级
  [POPUP_VIEW_TYPE.ORDER_OVERTIME]: 100, // 订单超时提醒优先级
  [POPUP_VIEW_TYPE.ORDER_PROMISE]: 101, // 订单超时准时保弹窗优先级
  [POPUP_VIEW_TYPE.BLOCK_RIDER]: 800, //拉黑骑手系列弹窗
  [POPUP_VIEW_TYPE.NPS_CARD_MODEL]: 900, // NPS弹窗
};

/**
 * 弹窗互斥白名单配置
 * 用于定义哪些弹窗类型可以与其他特定类型的弹窗同时出现。
 * 例如，订单详情弹窗（ORDER_SUMMARY）可以与订单配送反馈弹窗（ORDER_FEEDBACK）
 * 和订单评价订单弹窗（ORDER_EVALUATE）同时出现。
 */
const POPUP_VIEW_MUTEX_WHITE_LIST = {
  [POPUP_VIEW_TYPE.ORDER_SUMMARY]: [
    POPUP_VIEW_TYPE.ORDER_FEEDBACK,
    POPUP_VIEW_TYPE.ORDER_EVALUATE,
  ],
};

const POPUP_VIEW_TYPE_MASK = Object.values(POPUP_VIEW_TYPE).reduce((acc, value) => acc | value, 0);

/**
 * 优惠券使用状态
 */
enum PROMISE_DISPLAY_TYPE {
  NONE = 0, // 不展示标签
  ONTIME = 1, // 准时标签
  DELAY = 2, // 延时标签
}

enum DELIVERY_MODE {
  PLATFORM = 1001, // 平台配送
  POI = 9001, // 商家自配
}

export {
  PROMOTION_TYPE,
  POPUP_VIEW_TYPE,
  POPUP_VIEW_TYPE_MASK,
  POPUP_VIEW_MUTEX_WHITE_LIST,
  SKU_TAG_TYPE,
  LX_SKU_ACTIVITY_TYPE,
  LX_PROMO_DISHES_TYPE,
  USE_COUPON_STATUS,
  RESPONSE_ERROR_CODE,
  PROMISE_DISPLAY_TYPE,
  POPUP_VIEW_PRIORITY,
  ORDER_INFO_RESPONSE_BODY,
  DELIVERY_MODE
};
